import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface AdminGetPhoneOtcResponse extends BackendResponse {
  item: string;
}
export interface AdminGetPhoneOtcParameters extends NextApiParams {}

export const adminGetPhoneOtc = withNextApi<
  AdminGetPhoneOtcResponse,
  AdminGetPhoneOtcParameters
>("/cvp/CvpAdminGetPhoneOtc", { method: "GET" });
